import Types from "./types";

export default (errorId) => ({
	type: Types.NOTIFICATIONS_CLOSE_CLICKED,
	payload: errorId,
});
